<template>
    <div class="upload-con">
        <label class="upload" id="upload-file-cloud-btn">
            <div class="upload-ico"></div>
            <span class="upload-text">上传文件</span>
            <input class="upload-input f-hidden" accept=".zip,.rar,.7z,.ZIP" @change="uploadFile($event)"
                type="file">
        </label>
    </div>
</template>
<style lang="scss" scoped>
.upload-con {
    padding-bottom: 30px;
}
.upload {
    display: inline-block;
    position: relative;
    width: 90px;
    height: 27px;
    margin: 0 auto;
    box-sizing: border-box;
    border: 1px solid #fd7e28;
    border-radius: 2px;
    cursor: pointer;
}
.upload-ico {
    display: inline-block;
    width: 13px;
    height: 11px;
    margin-top: 6px;
    background-image: url(~Assets/img/pages/v4/icon.png);
    background-position: -348px -124px;
    vertical-align: top;
}
.upload-text {
    display: inline-block;
    margin-left: 4px;
    font-size: 12px;
    color: #fd7e28;
    line-height: 27px;
}
</style>

<script>
import axios from 'Services/axios.js';
import { UploadUrl, Uploadv2FilePutAuth, Uploadv2DemandzipUpload } from "Services/getData";
export default {
    name: "file-upload.vue",
    props: {
        uploader: {
            type: String,
            default: ''
        },
        error: {
            type: String,
            default: ''
        },
        maxSize: {
            type: Number,
            // 对象或数组默认值必须从一个工厂函数获取
            default: 500 * 1024 * 1024
        }
    },
    data() {
        return {
            errorMsg: {
                poptitle: "提示",
                content: "",
                confirmText: "确定"
            },

            file: '',
            fileName: '',
            fileSize: '',
            fileSrc: '',
            fileId: ''
        };
    },
    components: {
    },
    mounted() {
    },
    methods: {
        async uploadFile(e) {
            console.log(e)
            this.file = e.target.files[0];
            this.fileName = this.file.name;
            this.fileSize = this.file.size;
            const formatName = this.fileName.slice(this.fileName.lastIndexOf('.') + 1);
            if (!['rar', '7z', 'zip'].includes(formatName)) {
                this.$message.error('请上传JPG/PNG格式的图片');
                return;
            }
            if (this.file) {
                this.$emit('addfile', {
                    file: this.file,
                    fileName: this.fileName,
                    fileSize: this.fileSize
                });
                const res = await Uploadv2FilePutAuth({
                    name: this.fileName,
                    type: 40 // 需求单验收件
                })
                if (res.status === 200) {
                    const { authorization, path } = res.data.data;
                    this.putXml(authorization, path);
                } else {
                    this.uploadError();
                    this.$message.error(res.data && res.data.info);
                }
            }
        },
        putXml(authorization, path) {
            let that = this;
            let contentType = this.file.type.includes('application/x-zip-compressed') ? 'application/zip' : 'application/octet-stream';
            axios
                .put(path, this.file, {
                    headers: {
                        'Content-Type': contentType,
                        Authorization: authorization
                    }
                })
                .then(
                    res => {
                        // debugger;
                        // let xml = res.data;
                        // let xmlobj = new DOMParser().parseFromString(
                        //     xml,
                        //     'text/xml'
                        // );
                        // let img = xmlobj.getElementsByTagName('Location')[0]
                        //     .textContent;
                        // that.fileSrc = `${location.protocol}//${img}`;
                        this.saveFile(path);
                    },
                    err => {
                        this.$message.error('上传失败，请重新上传');
                        this.uploadError();
                    }
                );
        },
        async saveFile(path) {
            const res = await Uploadv2DemandzipUpload(this.$qs.stringify({
                fileName: this.fileName,
                fileUrl: path,
                size: this.fileSize
            }));
            if (res.status === 200 && res.data.code === 0) {
                this.fileId = res.data.data;
                this.$emit("completed", {
                    id: this.fileId,
                    file: this.file,
                    fileName: this.fileName,
                    fileSize: this.fileSize
                });
                this.$message.success('上传成功');
                this.loading = false;
            } else {
                this.uploadError();
            }
        },

        uploadError(uploader) {
            uploader.total.bytesPerSec = 0;
            uploader.total.statusTips = "上传失败";
            this.$emit('uploadFail');
            return uploader;
        },
        formatWaitTime(second) {
            return [
                parseInt(second / 60 / 60),
                parseInt((second / 60) % 60),
                second % 60
            ]
                .join(":")
                .replace(/\b(\d)\b/g, "0$1");
        },
        conver(limit) {
            let size = "";
            if (limit < 0.1 * 1024) {
                //如果小于0.1KB转化成B
                size = `${limit.toFixed(1)}B`;
            } else if (limit < 0.1 * 1024 * 1024) {
                //如果小于0.1MB转化成KB
                size = `${(limit / 1024).toFixed(1)}KB`;
            } else if (limit < 1 * 1024 * 1024 * 1024) {
                //如果小于1GB转化成MB
                size = `${(limit / (1024 * 1024)).toFixed(1)}MB`;
            } else {
                //其他转化成GB
                size = `${(limit / (1024 * 1024 * 1024)).toFixed(1)}GB`;
            }

            let sizestr = `${size}`;
            let len = sizestr.indexOf(".");
            let dec = sizestr.substr(len + 1, 2);
            if (dec == "00") {
                //当小数点后为00时 去掉小数部分
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
            }
            return sizestr;
        }
    }
};
</script>

